import i18n from "i18next";
import PillTabToggle from "@/Components/PillTabToggle";
import Bundle from "@/Pages/BuyFlow/Bundle";
import CustomBundle from "@/Pages/BuyFlow/CustomBundle";

export default function ChoosePlan({state, dispatch}) {
    return <div>
        <div className="d-flex justify-content-between header">
                <span className="titles">
                    <span className="step">{i18n.t('buy-flow.step-one')}</span>
                    <span className="step-title">{i18n.t('buy-flow.choose-plan')}</span>
                </span>
            <span className="contract-term-toggle">
                <PillTabToggle state={state}
                               dispatch={dispatch}
                               tabTitles={[i18n.t('buy-flow.monthly'), i18n.t('buy-flow.yearly'), i18n.t('buy-flow.three-year')]}/>
            </span>
        </div>
        <div className="scroll-div">
            <div className="step-container">
                <Bundle state={state} dispatch={dispatch} />
                <CustomBundle state={state} dispatch={dispatch}/>
            </div>
        </div>
    </div>
}
